// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ``, "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"clearSectionButtonColor": `#6C757D`,
	"clearAllButtonPrimary": `#F8F9FA`,
	"clearAllButtonDisabled": `#A1BFBE`,
	"buttonBorderRadius": `3.2px`,
	"buttonFontSize": `14px`
};
export default ___CSS_LOADER_EXPORT___;
